import TextField from "../../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";


import moment from "moment";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { ConvocarFeriasService } from "../../../../services/ConvocarFeriasService.js";
import { SolicitarFeriasService } from "../../../../services/SolicitarFeriasService.js";


export default {
  name: "ConvocarFerias",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    TextAreaField
  },

  props:{
    selected:{
      default: ""
    },
    periodo:{
      default: ""
    },
    numeroDias:{
      default:""
    }
  },

  data: () => ({
    form: {},
    justificativaRecusa: null,
    exerciciosOptions: [],

    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.initializeForm();
  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.initializeForm();      
      }
    },
    selected: function () {
      this.initializeForm();    
    }
  },

  mounted() {
    this.getByIdFerias();
  },

  methods: {

    async getByIdFerias(){
      const response = await ConvocarFeriasService.getByIdFerias(this.selected.id);
      this.justificativaRecusa = response.justificativa_recusa;
    },
  
    prepareForm() {

      if (this.form.dataCassacaoInicio == null) {
        SnackBarModule("Preencha o campo de data de cassação início", "error");
        return;
      }

      if (this.form.dataCassacaoFim == null) {
        SnackBarModule("Preencha o campo de data de cassação fim", "error");
        return;
      }

      if (this.form.diasCassacao == null) {
        SnackBarModule("Preencha o campo de dias de cassação", "error");
        return;
      }

      if (this.form.justificativa == null) {
        SnackBarModule("Preencha o campo de justificativa", "error");
        return;
      }

      // Validação se a data de convocação está dentro do período original das férias
      const dataInicioOriginal = moment(this.selected.dataIni);
      const dataFimOriginal = moment(this.selected.dataFin);
      const dataConvocacao = moment(this.form.dataCassacaoInicio);

      if (dataConvocacao.isBefore(dataInicioOriginal, 'day') || dataConvocacao.isAfter(dataFimOriginal, 'day')) {
        SnackBarModule("A data inicial da convocação deve estar dentro do período original das férias", "error");
        return;
      }

      try {
        const formData = new FormData();
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("data_ini", moment(this.form.dataCassacaoInicio).format("YYYY-MM-DD"));
        formData.append("data_fin", moment(this.form.dataCassacaoFim).format("YYYY-MM-DD"));
        formData.append("dias", this.form.diasCassacao);
        formData.append("id_usuario_convocacao", this.selected.idSigrh);
        formData.append("justificativa", this.form.justificativa);

        this.sendForm(formData);
      } catch (error) {
        console.error("Erro ao preparar os dados:", error);
      }

      return;
    },

    async calculateDays() {
      if (this.form.dataCassacaoInicio) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataCassacaoInicio).format("YYYY-MM-DD"));
        formData.append("dias", this.form.diasCassacao);
    
        try {
          const response = await SolicitarFeriasService.calcularDiasUteis(formData);
    
          this.form = {
            ...this.form,
            dataCassacaoFim: response.dataFim,
            diasCassacao: response.dias_uteis
          };
    
          console.log("Form atualizado:", this.form);
        } catch (error) {
          console.error("Erro ao calcular dias úteis:", error);
          SnackBarModule("Erro ao calcular dias úteis", "error");
        }
    
        return true;
      }
      return SnackBarModule("Preencha o campo de data inicial", "error");
    },      
    async sendForm(formData) {
      this.loading.btn = true;
      const response = await ConvocarFeriasService.postConvocarFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.$refs.form.reset();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      const re = /(\d{4})-(\d{2})-(\d{2})/g;
      const found = this.periodo.match(re);
      this.form = {
        dataInicio: found[0],
        dataFim: found[1],
        numeroDias:this.numeroDias,
        dataCassacaoInicio:null,
        dataCassacaoFim:null,
        diasCassacao:null,
        justificativa:""
      }
    },

    close() {
      this.$emit("on-close");
    },
  }
};